/**
 * Google OAuth — Web application clients (Google Cloud Console)
 *
 * **Project Checkup loopback warning:** Put `http://localhost:...` redirect URIs only on a
 * *development* OAuth client. The *production* client used for verification should list only
 * HTTPS redirect URIs (e.g. https://deckpack.app/oauth-callback). Use a second client for local / LAN dev:
 *   - Dev/LAN: `http://localhost:3000/oauth-callback`, `http://192.168.x.x:3000/oauth-callback`, etc. (add each exact URL in Google Cloud)
 *   - Prod: `https://deckpack.app/oauth-callback` (or your deployed host)
 * Set `REACT_APP_GOOGLE_OAUTH_CLIENT_ID` in `.env.local` (dev) to the dev client; production build uses
 * `.env.production` (prod client). Fallback CLIENT_ID below matches the current production app if env is unset.
 *
 * **Canonical redirect:** Set `REACT_APP_GOOGLE_OAUTH_REDIRECT_URI` in `.env.production` to one exact URL
 * that matches Console (reduces www vs apex mismatch and avoids shipping loopback in prod builds).
 *
 * Token endpoint: Web clients need client_secret on code + refresh. Prefer Cloudflare `functions/google-token-proxy.js`
 * (`REACT_APP_GOOGLE_TOKEN_PROXY_URL=/google-token-proxy`) + `GOOGLE_OAUTH_CLIENT_SECRET` as a Pages/Worker secret.
 * See wrangler.toml and `functions/google-token-proxy.js` headers.
 */
const trimmedEnvClientId =
  typeof process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID === 'string'
    ? process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID.trim()
    : '';

/** Used when `REACT_APP_GOOGLE_OAUTH_CLIENT_ID` is not set at build time. */
const FALLBACK_CLIENT_ID =
  '626392191639-6rj54035vk2krqniv6q9gt4m52s6lecf.apps.googleusercontent.com';

/** Browser API key (Picker API enabled). Not a client secret. */
export function getGooglePickerDeveloperKey() {
  const raw = process.env.REACT_APP_GOOGLE_PICKER_API_KEY;
  return typeof raw === 'string' ? raw.trim() : '';
}

/** Optional numeric Cloud project number for Picker metrics (`PickerBuilder.setAppId`). */
export function getGooglePickerAppId() {
  const raw = process.env.REACT_APP_GOOGLE_PICKER_APP_ID;
  return typeof raw === 'string' ? raw.trim() : '';
}

export const GOOGLE_CONFIG = {
  CLIENT_ID: trimmedEnvClientId || FALLBACK_CLIENT_ID,
  SCOPES: [
    'openid',
    'profile',
    'email',
    'https://www.googleapis.com/auth/drive.readonly',
    'https://www.googleapis.com/auth/drive.file',
    'https://www.googleapis.com/auth/drive',
    'https://www.googleapis.com/auth/presentations',
    'https://www.googleapis.com/auth/presentations.readonly',
  ].join(' '),
};
